import { Button, DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesToolPanel extends Layout {
    buttonAvailableLoads: Button;
    buttonCapacity: Button;
    buttonLaneHistory: Button;
    panel1: Panel;
    panel2: Panel;
    panelButtons: Panel;
    sourceCarrierSales: DataSource;
}
